export default {
  activities: state => state.activities,
};
